import { render } from "./editCourseSection.vue?vue&type=template&id=c579f204"
import script from "./editCourseSection.vue?vue&type=script&lang=js"
export * from "./editCourseSection.vue?vue&type=script&lang=js"

import "./editCourseSection.vue?vue&type=style&index=0&id=c579f204&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__